import React, { useState, useEffect, useRef } from "react";
import Modal from "react-bootstrap/Modal";
// import dsBankApi from "service/TichHopBank/dsBankApi";
// import userApi from "../../../service/userApi";
import { pushNotification } from "utils/notifications";
import ThietLapHienThiApi from "../../../service/QuanTriHeThong/ThietLapHienThiApi";

export const ModelThietLapHienThi = (props) => {
  const [data, setData] = useState({});
  const [dataChoVay, setDataChoVay] = useState({});

  const [isShowPhiKho, setisShowPhiKho] = useState({});
  const [SuDungPhiPhat_DongLai_TatToan, setSuDungPhiPhat_DongLai_TatToan] =
    useState(false);
  const [isCauHinhT86, setisCauHinhT86] = useState(false);
  const [SuDungPhiPhat_DongLai_Cham, setSuDungPhiPhat_DongLai_Cham] =
    useState(false);
  const [showPhiPhat, setshowPhiPhat] = useState(false);

  const [bDisable, setDisableButton] = useState(false);
  useEffect(() => {
    setData(props.data);
    setDataChoVay(props.dataChoVay);

    setisShowPhiKho(props.isShowPhiKho);
    setSuDungPhiPhat_DongLai_TatToan(props.SuDungPhiPhat_DongLai_TatToan);
    setisCauHinhT86(props.isCauHinhT86);

    setSuDungPhiPhat_DongLai_Cham(props.SuDungPhiPhat_DongLai_Cham);
    setshowPhiPhat(props.showPhiPhat);
  }, []);

  const toggleCheckThietLap = (e, field) => {
    const checked = !e.target?.checked ?? true;
    setData((prev) => ({
      ...prev,
      [field]: checked,
    }));
  };
  const addOrEdit = () => {
    setDisableButton(true);
    ThietLapHienThiApi.saveThietLapDongLai(data).then((response) => {
      setDisableButton(false);
      if (response.status === 200) {
        props.onHide();
        props.getThietLapHienThi();
        pushNotification("Thao tác thành công", "success", "TOP_CENTER", 2000);
      } else {
        pushNotification(response, "error", "TOP_CENTER", 2000);
      }
    });
  };
  return (
    <Modal
      {...props}
      size="modal-dialog"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="fade modal-new modal fade text-left modal show"
      backdrop="static"
    >
      <Modal.Header>
        <h4 className="modal-title" id="myModalLabel16">
          <span className="btn-icon-right">
            <i className="fa fa-cog"></i>
          </span>
         <span className="btn-link color-xanh">Thiết lập hiển thị</span>
        </h4>
        <button
          type="button"
          className="close-popup-new"
          onClick={props.onHide}
        >
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col-lg-6">
            <div className="row">
              <div className="col-md-1">
                <input
                  style={{ marginRight: "10px" }}
                  type="checkbox"
                  checked={!data.IsAnSTT}
                  onChange={(e) => toggleCheckThietLap(e, "IsAnSTT")}
                />
              </div>
              <div className="col-md-8">
                <label className="label-control">STT</label>
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="row">
              <div className="col-md-1">
                <input
                  style={{ marginRight: "10px" }}
                  type="checkbox"
                  checked={!data.IsAnNgayTraLai}
                  onChange={(e) => toggleCheckThietLap(e, "IsAnNgayTraLai")}
                />
              </div>
              <div className="col-md-8">
                <label className="label-control">Ngày trả</label>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          {(dataChoVay.StatusPaidHo !== 1 || dataChoVay.Type !== 2) &&
            dataChoVay.Type !== 5 && (
              <div className="col-lg-6">
                <div className="row">
                  <div className="col-md-1">
                    <input
                      style={{ marginRight: "10px" }}
                      type="checkbox"
                      checked={!data.IsAnTienLai}
                      onChange={(e) => toggleCheckThietLap(e, "IsAnTienLai")}
                    />
                  </div>
                  <div className="col-md-8">
                    <label className="label-control">Tiền lãi</label>
                  </div>
                </div>
              </div>
            )}
          {dataChoVay.StatusPaidHo === 1 && dataChoVay.Type === 2 && (
            <div className="col-lg-6">
              <div className="row">
                <div className="col-md-1">
                  <input
                    style={{ marginRight: "10px" }}
                    type="checkbox"
                    checked={!data.IsAnTienLai}
                    onChange={(e) => toggleCheckThietLap(e, "IsAnTienLai")}
                  />
                </div>
                <div className="col-md-8">
                  <label className="label-control">Tiền góp</label>
                </div>
              </div>
            </div>
          )}
        </div>
        {/* -------------- */}
        <div className="row">
          {dataChoVay.Type == 5 && (
            <div className="col-lg-6">
              <div className="row">
                <div className="col-md-1">
                  <input
                    style={{ marginRight: "10px" }}
                    type="checkbox"
                    checked={!data.IsAnKyGop}
                    onChange={(e) => toggleCheckThietLap(e, "IsAnKyGop")}
                  />
                </div>
                <div className="col-md-8">
                  <label className="label-control">Kỳ góp</label>
                </div>
              </div>
            </div>
          )}
          {(dataChoVay.StatusPaidHo !== 1 || dataChoVay.Type !== 2) && dataChoVay.Type !== 5  && (
            <div className="col-lg-6">
              <div className="row">
                <div className="col-md-1">
                  <input
                    style={{ marginRight: "10px" }}
                    type="checkbox"
                    checked={!data.IsAnTienGoc}
                    onChange={(e) => toggleCheckThietLap(e, "IsAnTienGoc")}
                  />
                </div>
                <div className="col-md-8">
                  <label className="label-control">Tiền gốc</label>
                </div>
              </div>
            </div>
          )}
        </div>
        {/* -------------- */}
        <div className="row">
          <div className="col-lg-6">
            <div className="row">
              <div className="col-md-1">
                <input
                  style={{ marginRight: "10px" }}
                  type="checkbox"
                  checked={!data.IsAnPhiKhac}
                  onChange={(e) => toggleCheckThietLap(e, "IsAnPhiKhac")}
                />
              </div>
              <div className="col-md-8">
                <label className="label-control">Phí khác</label>
              </div>
            </div>
          </div>
          {isShowPhiKho === 1 &&
            dataChoVay.Type == 3 &&
            isCauHinhT86 == false && (
              <div className="col-lg-6">
                <div className="row">
                  <div className="col-md-1">
                    <input
                      style={{ marginRight: "10px" }}
                      type="checkbox"
                      checked={!data.IsAnPhiKho}
                      onChange={(e) => toggleCheckThietLap(e, "IsAnPhiKho")}
                    />
                  </div>
                  <div className="col-md-8">
                    <label className="label-control">Phí kho</label>
                  </div>
                </div>
              </div>
            )}
        </div>
        <div className="row">
          {SuDungPhiPhat_DongLai_TatToan && (
            <div className="col-lg-6">
              <div className="row">
                <div className="col-md-1">
                  <input
                    style={{ marginRight: "10px" }}
                    type="checkbox"
                    checked={!data.IsAnPhiChamDongLaiTatToan1}
                    onChange={(e) =>
                      toggleCheckThietLap(e, "IsAnPhiChamDongLaiTatToan1")
                    }
                  />
                </div>
                <div className="col-md-8">
                  <label className="label-control">Phạt chậm đóng lãi</label>
                </div>
              </div>
            </div>
          )}
          {SuDungPhiPhat_DongLai_Cham && (
            <div className="col-lg-6">
              <div className="row">
                <div className="col-md-1">
                  <input
                    style={{ marginRight: "10px" }}
                    type="checkbox"
                    checked={!data.IsAnPhiChamDongLaiTatToan}
                    onChange={(e) =>
                      toggleCheckThietLap(e, "IsAnPhiChamDongLaiTatToan")
                    }
                  />
                </div>
                <div className="col-md-8">
                  <label className="label-control"> Phí Phạt</label>
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="row">
          {showPhiPhat && (
            <div className="col-lg-6">
              <div className="row">
                <div className="col-md-1">
                  <input
                    style={{ marginRight: "10px" }}
                    type="checkbox"
                    checked={!data.IsAnPhiPhat}
                    onChange={(e) => toggleCheckThietLap(e, "IsAnPhiPhat")}
                  />
                </div>
                <div className="col-md-8">
                  <label className="label-control">Phí phạt</label>
                </div>
              </div>
            </div>
          )}
          {(dataChoVay.StatusPaidHo === 3 ||
            dataChoVay.IsDuNoGiamDan === true ||
            dataChoVay.IsKieuTraGocLai === true) && (
            <div className="col-lg-6">
              <div className="row">
                <div className="col-md-1">
                  <input
                    style={{ marginRight: "10px" }}
                    type="checkbox"
                    checked={!data.IsAnKhoanVay}
                    onChange={(e) => toggleCheckThietLap(e, "IsAnKhoanVay")}
                  />
                </div>
                <div className="col-md-8">
                  <label className="label-control"> Khoản vay</label>
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="row">
          {(dataChoVay.StatusPaidHo === 3 ||
            dataChoVay.IsDuNoGiamDan === true ||
            dataChoVay.IsKieuTraGocLai === true) && (
            <div className="col-lg-6">
              <div className="row">
                <div className="col-md-1">
                  <input
                    style={{ marginRight: "10px" }}
                    type="checkbox"
                    checked={!data.IsAnNoGocConLai}
                    onChange={(e) => toggleCheckThietLap(e, "IsAnNoGocConLai")}
                  />
                </div>
                <div className="col-md-8">
                  <label className="label-control">Nợ gốc còn lại</label>
                </div>
              </div>
            </div>
          )}

          <div className="col-lg-6">
            <div className="row">
              <div className="col-md-1">
                <input
                  style={{ marginRight: "10px" }}
                  type="checkbox"
                  checked={!data.IsAnCanThanhToan}
                  onChange={(e) => toggleCheckThietLap(e, "IsAnCanThanhToan")}
                />
              </div>
              <div className="col-md-8">
                <label className="label-control"> Cần thanh toán</label>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-6">
            <div className="row">
              <div className="col-md-1">
                <input
                  style={{ marginRight: "10px" }}
                  type="checkbox"
                  checked={!data.IsAnDaThanhToan}
                  onChange={(e) => toggleCheckThietLap(e, "IsAnDaThanhToan")}
                />
              </div>
              <div className="col-md-8">
                <label className="label-control">Đã thanh toán</label>
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="row">
              <div className="col-md-1">
                <input
                  style={{ marginRight: "10px" }}
                  type="checkbox"
                  checked={!data.IsAnCacLanDong}
                  onChange={(e) => toggleCheckThietLap(e, "IsAnCacLanDong")}
                />
              </div>
              <div className="col-md-8">
                <label className="label-control"> Các lần đóng</label>
              </div>
            </div>
          </div>
           <div className="col-lg-6">
            <div className="row">
              <div className="col-md-1">
                <input
                  style={{ marginRight: "10px" }}
                  type="checkbox"
                  checked={!data.IsAnPhiHangKy}
                  onChange={(e) => toggleCheckThietLap(e, "IsAnPhiHangKy")}
                />
              </div>
              <div className="col-md-8">
                <label className="label-control"> Phí hàng kỳ</label>
              </div>
            </div>
          </div>
           <div className="col-lg-6">
            <div className="row">
              <div className="col-md-1">
                <input
                  style={{ marginRight: "10px" }}
                  type="checkbox"
                  checked={!data.IsAnPhiKho}
                  onChange={(e) => toggleCheckThietLap(e, "IsAnPhiKho")}
                />
              </div>
              <div className="col-md-8">
                <label className="label-control"> Phí kho</label>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6">
            <div className="row">
              <div className="col-md-1">
                <input
                  style={{ marginRight: "10px" }}
                  type="checkbox"
                  checked={!data.IsAnConPhaiTra}
                  onChange={(e) => toggleCheckThietLap(e, "IsAnConPhaiTra")}
                />
              </div>
              <div className="col-md-8">
                <label className="label-control"> Còn phải trả</label>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="row">
              <div className="col-md-1">
                <input
                  style={{ marginRight: "10px" }}
                  type="checkbox"
                  checked={!data.IsAnThaoTac}
                  onChange={(e) => toggleCheckThietLap(e, "IsAnThaoTac")}
                />
              </div>
              <div className="col-md-8">
                <label className="label-control">Thao tác</label>
              </div>
            </div>
          </div>
        </div>

        <div style={{ textAlign: "center" }}>
          <p></p>
        </div>
      </Modal.Body>
      <Modal.Footer className="modal-footer button-popup-new-size">
        <button
          className="btn btn-new-main btn-checknew"
          onClick={addOrEdit}
          disabled={bDisable}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-check"></i>
          </span>
          Cập nhật
        </button>

        <a
          className="btn btn-new-main btn-closenew"
          data-dismiss="modal"
          href={() => false}
          onClick={props.onHide}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-close"></i>
          </span>{" "}
          Đóng
        </a>
      </Modal.Footer>
    </Modal>
  );
};
